import { INav } from '@/components/Nav/utilities';

export const headerLinks: INav[] = [
  {
    name: 'Why Primary?',
    items: [
      {
        name: 'The Paradigm Shift',
        items: [
          {
            name: 'Data Security',
            description:
              'Explore Primary’s  advanced security  features, including  zero-trust  architecture and data protection for  modern enterprises.',
            href: '/security',
          },
          {
            name: 'Data Visibility',
            description:
              'Achieve full  visibility with  Primary’s detailed  activity tracking  and real-time  insights.',
            href: '/visibility',
          },
          {
            name: 'Data Control',
            description:
              'Gain precise control with Primary’s tools for secure access, policy enforcement, and activity oversight.',
            href: '/control',
          },
          // {
          //   name: 'How the Landscape has changed',
          //   description:
          //     'Understand how  Primary adapts to  the evolving  security landscape  to protect modern  enterprises',
          //   href: '/landscape-changed',
          // },
        ],
      },
      {
        name: 'What is Primary',
        items: [
          {
            name: 'Why do you need Primary',
            description:
              'Learn how Primary’s Policy Engine transforms security, control, and efficiency for businesses.',
            href: '/why-do-you-need-primary',
          },
          {
            name: 'What is Primary',
            description:
              'Learn how Primary’s Policy Engine transforms security, control, and efficiency for businesses.',
            href: '/what-is-primary',
          },

          {
            name: 'Making the Switch',
            description:
              'Optimize SaaS security with Primary’s seamless integration and robust data protection.',
            href: '/making-the-switch',
          },
          // {
          //   name: 'The Preferred Browser by Users',
          //   description:
          //     'Discover why users trust Primary for secure, seamless, and efficient browsing experiences.',
          //   href: '/',
          // },
          {
            name: 'Zero Trust Architecture',
            description:
              'A control plane that never assumes trust—continuously verifying every identity, request, action, and data interaction.',
            href: '/zero-trust-architecture',
          },
        ],
      },
    ],
  },
  {
    name: 'Platform',
    items: [
      {
        name: 'Zero Trust Security',
        items: [
          {
            name: 'Zero Trust Pillars',
            description:
              'Explore Primary’s 7 Pillars of Zero Trust, the foundation for secure, scalable Data Control.',
            href: '/zero-trust-pillars',
          },
          {
            name: 'Zero Trust Security',
            description:
              'Embrace Zero Trust with Primary’s secure Control Plane for identity-driven protection.',
            href: '/zero-trust-security',
          },
          // {
          //   name: 'Security by Design',
          //   description:
          //     'Discover how Primary’s architecture is built from the ground up to ensure enterprise-grade security.',
          //   href: '/',
          // },
          // {
          //   name: 'Private Browsing',
          //   description:
          //     'Ensure your company’s sensitive data is protected from malware, viruses and trackers through built-in Private Browsing technology.',
          //   href: '/private-browsing',
          // },
        ],
      },
      {
        name: 'Unified Control Plane',
        items: [
          {
            name: 'Unified Control Plane',
            description:
              'Govern activity across users, agents, applications, and data through one connected, auditable control plane.',
            href: '/enterprise-control-plane',
          },
          // {
          //   name: 'SaaS Auditing',
          //   description:
          //     'Track, monitor, and secure SaaS usage with Primary’s robust auditing tools.',
          //   href: '/',
          // },
        ],
      },
      {
        name: 'Compliance',
        items: [
          {
            name: 'Identity Governance',
            description:
              'Govern every identity, permission, and action across human and agentic actors from one control plane.',
            href: '/identity-governance',
          },
          {
            name: 'Attribute-Based Access Control',
            description:
              'Enforce precise, real-time access decisions based on identity, context, data sensitivity, and risk.',
            href: '/attribute-based-access-control',
          },
          {
            name: 'Agent Control Planes',
            description:
              'Control, coordination, and trust for the agentic enterprise—governing how AI agents act at scale.',
            href: '/agent-control-planes',
          },
          {
            name: 'AI Cost Governance',
            description:
              'Simplified cost governance for enterprise AI—bring FinOps discipline to agentic and model spend.',
            href: '/ai-cost-governance',
          },
        ],
      },
      {
        name: 'Partners & Integrations',
        items: [
          {
            name: 'Partner with Us',
            description:
              'Join Primary’s Partner Program to offer secure solutions and drive business growth.',
            href: '/partner-program',
          },
          // {
          //   name: 'Integrations & Documentation',
          //   description: 'Lorem Ipsum',
          //   href: '/',
          // },
        ],
      },
    ],
  },
  {
    name: 'Solutions',
    items: [
      {
        name: 'Features',
        items: [
          {
            name: 'Enterprise Workspace',
            description:
              'Own the workspace and govern every direction—protect, track, and control your digital assets with ease.',
            href: '/enterprise-workspace',
          },
          {
            name: 'AI Classification',
            description:
              'Discover how Primary’s AI-driven classification system automatically categorizes and protects your data to enhance security and compliance.',
            href: '/ai-classification',
          },
          /* Unified Governance page hidden — remove this comment wrapper to restore
          {
            name: 'Unified Governance',
            description:
              'Govern humans, AI, data, and applications consistently across every interaction and touchpoint.',
            href: '/unified-governance',
          }
          */
          // {
          //   name: 'Resilient Cybersecurity Continuity',
          //   description:
          //     'Primary acts as a fail-safe for critical business operations, ensuring security and access during outages or disruptions.',
          //   href: '/resilient-cybersecurity-continuity',
          // },
        ],
      },
      /* Industries section hidden — remove this comment wrapper to restore
      {
        name: 'Industries',
        items: [
          {
            name: 'Healthcare',
            description:
              'Protect patient data, prevent cyber threats, and ensure HIPAA compliance with Primary’s Zero Trust Enterprise Browser.',
            href: '/healthcare',
          },
          {
            name: 'Education',
            description:
              'Discover how Primary’s solutions address key challenges across various industries with real world use cases.',
            href: '/education',
          },
          {
            name: 'Federal',
            description:
              'Comprehensive and secure solution for collaboration, storage, governance and compliance.',
            href: '/federal',
          },
          {
            name: 'Law',
            description:
              'Protect your operations against cyber threats while offering a seamless work experience to your staff.',
            href: '/law',
          },
          {
            name: 'Manufacturing',
            description:
              'Discover how Primary enhances security, compliance, and operational efficiency for the manufacturing industry.',
            href: '/manufacturing',
          },
          {
            name: 'Financial Services',
            description:
              'Discover how Primary enhances security, compliance, and efficiency for the financial services industry.',
            href: '/financial-services',
          },
          {
            name: 'Oil & Gas',
            description:
              'Explore how Primary can strengthen security and ensure compliance for the oil and gas sector.',
            href: '/oil-and-gas',
          },
          {
            name: 'Engineering & Construction',
            description:
              'Facilitate real-time collaboration on designs, blueprints, and projects while ensuring data security and compliance. ',
            href: '/construction',
          },
          {
            name: 'Digital Marketing',
            description:
              'Protect Client Data, Enhance Collaboration, and Boost Productivity with a Browser Built for Modern Marketing Needs.',
            href: '/digital-marketing',
          },
          {
            name: 'Accounting & Tax',
            description:
              'Learn how Primary strengthens security, compliance, and collaboration for accounting and tax consulting firms.',
            href: '/tax-firms',
          },
        ],
      },
      */
    ],
  },
  {
    name: 'Learn',
    items: [
      {
        name: 'The Company',
        items: [
          {
            name: 'About Primary',
            description:
              'Learn about Primary’s mission, values, and commitment to transforming enterprise security.',
            href: '/about',
          },
          {
            name: 'The Primary Executive Team',
            description:
              "The Primary executive team is dedicated to maintaining the firm's highest standards of excellence, serving our clients, shareholders, and employees with unwavering commitment.",
            href: '/team',
          },
          {
            name: 'Careers',
            description:
              'Join our team and help shape the future of enterprise security at Primary.',
            href: '/careers',
          },
          // Comment this entry out to keep /events reachable but unlinked.
          {
            name: 'Events',
            description:
              'Meet Primary in person at conferences, executive briefings, and after-hours events around the world.',
            href: '/events',
          },
        ],
      },
      {
        name: 'Knowledge Center',
        items: [
          {
            name: 'Blog',
            description:
              'Explore the latest insights, trends, and updates on enterprise security and technology curated by us.',
            href: '/blog',
          },
          // {
          //   name: 'Use Cases',
          //   description:
          //     'Discover how Primary’s solutions address key challenges across various industries with real world use cases.',
          //   href: '/',
          // },
          // {
          //   name: 'Primary University',
          //   description: 'Lorem Ipsum',
          //   href: '/',
          // },
        ],
      },
    ],
  },
];
